module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("感谢赞助商")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("感谢捐赠用户")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("即将上线，捐赠时的附加信息也将显示在这里。")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("捐赠方式")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("欢迎通过下面渠道进行捐赠")])]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "best-companies"
  }, [_c('a', {
    attrs: {
      "href": "https://www.bmqb.com/a/jobs?tracking_code=opencollective",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://ww1.sinaimg.cn/large/663d3650gy1fs3l6w13z2j206y02bdfp.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.upyun.com",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "52px"
    },
    attrs: {
      "src": "https://ww1.sinaimg.cn/large/663d3650gy1fs3l83hokej20b4040weg.jpg"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.sb/?utm_source=vux"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://wx1.sinaimg.cn/mw690/0060lm7Tly1ftmvim3r34j3056034wee.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.patreon.com/airyland"
    }
  }, [_vm._v("Patreon")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://opencollective.com/vux"
    }
  }, [_vm._v("Open Collective")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://paypal.me/airyland"
    }
  }, [_vm._v("PayPal")])]), _vm._v(" "), _c('li', [_vm._v("支付宝 airyland@qq.com")]), _vm._v(" "), _c('li', [_vm._v("企业赞助捐赠请联系 i@mao.li")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1f949b90", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-1f949b90"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/donate-273.vue
// module id = 2082
// module chunks = 440